import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../utils/api";

const AdminLogin = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const [msg, setMsg] = useState("");

  React.useEffect(() => {
    const isLogin = localStorage.getItem("adminLogin") === "true";
    const token = localStorage.getItem("adminToken");

    if (isLogin && token) {
      navigate("/admin/dashboard");
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");

    try {
      const data = await loginAdmin(form.username, form.password);

      localStorage.setItem("adminLogin", "true");
      localStorage.setItem("adminToken", data.token);
      localStorage.setItem("admin", JSON.stringify(data.admin));

      navigate("/admin/dashboard");
    } catch (err) {
      console.log("STATUS:", err.response?.status);
      console.log("DATA:", err.response?.data);

      setMsg(err.response?.data?.message || "Login failed");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-900 to-green-800 flex items-center justify-center px-4 font-[Poppins]">
      <form
        onSubmit={submit}
        className="bg-white rounded-[28px] shadow-2xl p-8 w-full max-w-md"
      >
        <h1 className="text-3xl font-extrabold text-sky-950 mb-2">
          Admin Login
        </h1>

        <p className="text-slate-500 mb-6">Secure admin access</p>

        {msg && (
          <div className="mb-4 bg-red-50 text-red-700 p-3 rounded-xl text-sm">
            {msg}
          </div>
        )}

        <input
          className="w-full border rounded-xl px-4 py-3 mb-4"
          value={form.username}
          onChange={(e) => setForm({ ...form, username: e.target.value })}
          placeholder="Username"
          autoComplete="username"
        />

        <input
          className="w-full border rounded-xl px-4 py-3 mb-5"
          type="password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          placeholder="Password"
          autoComplete="current-password"
        />

        <button className="w-full bg-sky-900 text-white rounded-xl py-3 font-bold">
          Login
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;